var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sgp-page sgp-profile" },
    [
      !_vm.loading
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _vm.manager
                ? _c("div", { staticClass: "card card-widget widget-user-2" }, [
                    _c("div", { staticClass: "widget-user-header" }, [
                      _c("div", { staticClass: "widget-user-image" }, [
                        _c("img", {
                          staticClass: "img-circle elevation-2",
                          attrs: { src: _vm.manager.image, alt: "User Avatar" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "widget-user-username" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.manager.name) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h5", { staticClass: "widget-user-desc" }, [
                        _vm._v(
                          "\n                        Account Manager\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card-footer p-0",
                        staticStyle: { "background-color": "#EAEAEB" },
                      },
                      [
                        _c("ul", { staticClass: "nav flex-column" }, [
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                staticStyle: { color: "#000000" },
                                attrs: { href: `mailto:${_vm.manager.email}` },
                              },
                              [
                                _vm._v(
                                  "\n                                Email "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "float-right badge",
                                    staticStyle: { color: "#EC008C" },
                                  },
                                  [_vm._v(_vm._s(_vm.manager.email))]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.manager.calendly_link !== null
                            ? _c("div", [
                                _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-block btn-default sgp-btn-default",
                                      attrs: {
                                        type: "button",
                                        href: _vm.manager.calendly_link,
                                        target: "_blank",
                                        "data-toggle": "tooltip",
                                        "data-placement": "top",
                                        title:
                                          "Click here to schedule a call with your account manager.",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Schedule a Call\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card card-primary" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c(
                      "dl",
                      { staticClass: "row" },
                      [
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Project Name\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.project_name) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Project Title\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.friendly_project_name) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Project ID\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.project_id) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Shoot Type\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.shoot_type) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Picture Dates\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.project.dates.picture_dates || "N/A"
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-3" }, [
                          _vm._v(
                            "\n                            Makeup Dates\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-9" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.dates.retake_dates || "N/A") +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.project.student_count
                          ? [
                              _c("dt", { staticClass: "col-md-3" }, [
                                _vm._v(
                                  "\n                                # of Students\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-md-9" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.project.student_count) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.project.staff_count
                          ? [
                              _c("dt", { staticClass: "col-md-3" }, [
                                _vm._v(
                                  "\n                                # of Staff\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-md-9" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.project.staff_count) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.project.staff_pictures
                          ? [
                              _c("dt", { staticClass: "col-md-3" }, [
                                _vm._v(
                                  "\n                                Do you want staff pictures?\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-md-9" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.project.staff_pictures) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.project.school_payment_option
                          ? [
                              _c("dt", { staticClass: "col-md-3" }, [
                                _vm._v(
                                  "\n                                School Pays\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-md-9" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.project.school_payment_option) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.project.amount
                                ? [
                                    _c("dt", { staticClass: "col-md-3" }, [
                                      _vm._v(
                                        "\n                                    Amount\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", {
                                      staticClass: "col-md-9",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.project.amount),
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.project.dates.retake_dates &&
                    _vm.project.dates.retake_dates !== "N/A"
                      ? [
                          _c("hr"),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-lg-12" }, [
                            _vm._v(
                              "\n                            Makeup Day Sign-Up Link\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.project.makeup_day_link
                            ? _c("dd", { staticClass: "col-lg-12" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.project.makeup_day_link,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.project.makeup_day_link) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ])
                            : _c("dd", { staticClass: "col-lg-12" }, [
                                _vm._v(
                                  "\n                            N/A\n                        "
                                ),
                              ]),
                          _vm._v(" "),
                          _c(
                            "dd",
                            { staticClass: "col-lg-12" },
                            [_c("makeup-day-link")],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.project.picture_day_job_summary ||
                    _vm.project.makeup_day_job_summary
                      ? [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "dl",
                            { staticClass: "row" },
                            [
                              _vm.project.picture_day_job_summary
                                ? [
                                    _c("dt", { staticClass: "col-lg-12" }, [
                                      _vm._v(
                                        "\n                                    Picture Day Job Summary\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", { staticClass: "col-lg-12" }, [
                                      _c(
                                        "ol",
                                        _vm._l(
                                          _vm.project.picture_day_job_summary,
                                          function (item, index) {
                                            return _c(
                                              "li",
                                              { key: `item_${index}` },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(item) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.project.makeup_day_job_summary
                                ? [
                                    _c("dt", { staticClass: "col-lg-12" }, [
                                      _vm._v(
                                        "\n                                    Makeup Day Job Summary\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", { staticClass: "col-lg-12" }, [
                                      _c(
                                        "ol",
                                        _vm._l(
                                          _vm.project.makeup_day_job_summary,
                                          function (item, index) {
                                            return _c(
                                              "li",
                                              { key: `item_${index}` },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(item) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-primary" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("dt", { staticClass: "col-md-4" }, [
                      _vm._v(
                        "\n                            Building Address\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-md-8" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.project.actual_school.location || "TBD") +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-md-4" }, [
                      _vm._v(
                        "\n                            Building Access\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-md-8" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.project.building_access),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-md-4" }, [
                      _vm._v(
                        "\n                            Picture Day Location\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", {
                      staticClass: "col-md-8",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.project.picture_day_set_location || "TBD"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-md-4" }, [
                      _vm._v(
                        "\n                            Equipment Notes\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", {
                      staticClass: "col-md-8",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.project.picture_day_equip_notes || "TBD"
                        ),
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-primary" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", { staticClass: "row" }, [
                    _c(
                      "dt",
                      { staticClass: "col-lg-12 font-weight-bold font-italic" },
                      [
                        _vm._v(
                          "\n                            THIS YEAR\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-8" }, [
                      _vm._v(
                        "\n                            Portrait Background Color\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.project.portrait_background_color
                      ? _c("dd", { staticClass: "col-lg-4" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.portrait_background_color) +
                              "\n                        "
                          ),
                        ])
                      : _c("dd", { staticClass: "col-lg-4" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-block sgp-btn-default",
                              attrs: { type: "button" },
                              on: { click: _vm.onSelectColor },
                            },
                            [
                              _vm._v(
                                "\n                                Select Background Color\n                            "
                              ),
                            ]
                          ),
                        ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-8" }, [
                      _vm._v(
                        "\n                            Group Background Color\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-4" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.project.group_background || "N/A") +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "dt",
                      { staticClass: "col-lg-12 font-weight-bold font-italic" },
                      [
                        _vm._v(
                          "\n                            LAST YEAR\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-8" }, [
                      _vm._v(
                        "\n                            Portrait Background Color\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-4" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.project.last_year_portrait_background_color ||
                              "N/A"
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-8" }, [
                      _vm._v(
                        "\n                            Group Background Color\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-4" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.project.last_year_group_background || "N/A"
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-primary" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.project.contact_info) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.project.main_contact),
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.project.shipping_contact),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.project.cc_delivery_emails),
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.project.portal_users),
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-primary" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", { staticClass: "row" }, [
                    _c("dt", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            Is school or Parent Association providing parent emails?\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.project.school_provide_emails || "N/A") +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            Student Online Code is currently set as:\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.project.online_code_configuration || "N/A"
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            Physical Proofs?\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "col-lg-12" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.project.proofs || "N/A") +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.project.comm_details) },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _vm.project.fundraising_agreement !== null
                ? _c("div", [
                    _c("div", { staticClass: "card card-primary" }, [
                      _vm._m(10),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("dl", { staticClass: "row" }, [
                          _c("dt", { staticClass: "col-md-3" }, [
                            _vm._v(
                              "\n                                Agreement\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-md-9" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.project.fundraising_agreement) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-md-3" }, [
                            _vm._v(
                              "\n                                Check Payable To\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-md-9" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.project.check_payable_to) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dt", { staticClass: "col-md-3" }, [
                            _vm._v(
                              "\n                                Contact(s)\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "col-md-9" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.project.fundraising_contacts
                                ),
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.project.students_booked || _vm.project.staff_booked
                ? _c("div", { staticClass: "card" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("dt", { staticClass: "col-md-4" }, [
                          _vm._v(
                            "\n                            Students Booked\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-8" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.students_booked) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dt", { staticClass: "col-md-4" }, [
                          _vm._v(
                            "\n                            Staff Booked\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "col-md-8" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.project.staff_booked) +
                              "\n                        "
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("school-logo"),
                _vm._v(" "),
                _vm.project.picture_day_link || _vm.project.staff_gallery_link
                  ? _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _vm.project.picture_day_link
                            ? _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-block btn-default sgp-btn-default",
                                    attrs: {
                                      type: "button",
                                      target: "_blank ",
                                      href: _vm.project.picture_day_link,
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title: "Click to view and share.",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Picture Day Page\n                            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.project.staff_gallery_link
                            ? _c("div", { staticClass: "col-12 mt-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-block btn-default sgp-btn-default",
                                    attrs: {
                                      type: "button",
                                      target: "_blank ",
                                      href: _vm.project.staff_gallery_link,
                                      "data-toggle": "tooltip",
                                      "data-placement": "top",
                                      title:
                                        "Click here to view your staff gallery.",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                View Staff Gallery\n                            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("default"),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("select-color", {
        ref: "selectColor",
        attrs: { "project-id": _vm.projectId },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Project Details")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Location Details")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Background Colors")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("To see the SGP background colors, click "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.stompinggroundphoto.com/background-colors",
            target: "_blank",
          },
        },
        [_vm._v("here")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [_vm._v("Contact Information")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("u", [_vm._v("Primary School Picture Contact")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("u", [_vm._v("Shipping Contact")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("u", [
        _vm._v("Additional people to be emailed when service items are ready"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("u", [_vm._v("Portal Users")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("Communication Details"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("Fundraising Information"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("strong", [_vm._v("Remote Bookings")]),
      _vm._v(" "),
      _c("div", { staticClass: "card-tools" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-tool",
            attrs: { type: "button", "data-card-widget": "collapse" },
          },
          [_c("i", { staticClass: "fas fa-minus" })]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }